import { render, staticRenderFns } from "./promo-grid-view.vue?vue&type=template&id=12543e23"
import script from "./promo-grid-view.vue?vue&type=script&lang=ts"
export * from "./promo-grid-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12543e23')) {
      api.createRecord('12543e23', component.options)
    } else {
      api.reload('12543e23', component.options)
    }
    module.hot.accept("./promo-grid-view.vue?vue&type=template&id=12543e23", function () {
      api.rerender('12543e23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/promo-grid-view.vue"
export default component.exports